import { IExercise } from '../types/interfaces/exercise';
import { ILanguage } from '../types/interfaces/language';

export const isExerciseTranslationIncomplete = (
  exercise: IExercise,
  languages?: ILanguage[],
): boolean => {
  if (!exercise || !languages) return false;
  const exerciseTranslations = exercise.exerciseTranslations ?? [];
  const requiredLanguageIds = new Set(
    languages
      .map((language) => language?.id)
      .filter((id): id is string => typeof id === 'string' && id.length > 0),
  );
  const completedLanguageIds = new Set<string>();

  exerciseTranslations.forEach((translation) => {
    const languageId = translation?.languageId;
    if (!languageId || !requiredLanguageIds.has(languageId)) return;

    const hasTitle = !!translation.title?.trim();
    const hasDescription = !!translation.description?.trim();
    if (hasTitle && hasDescription) {
      completedLanguageIds.add(languageId);
    }
  });

  return requiredLanguageIds.size !== completedLanguageIds.size;
};
